<template>
    <div class="flex flex-col">
        <h2 class="text-2xl md:text-4xl font-semibold mb-6">Referral for Testing</h2>

        <ul class="list-disc pl-4 font-light">
            <li>A kidney allograft transplant was scheduled based on CT scan and blood test results</li>
            <li>
                The patient started post-operative standard therapy to prevent kidney allograft rejection, with routine
                monitoring in follow-up
            </li>
            <li>Allograft rejection was suspected, and a kidney biopsy and genetic tests were performed</li>
        </ul>

        <img
            src="@/assets/img/graphics/transplant/referral-for-testing-desktop.svg"
            alt="Referral for Testing"
            class="hidden md:block"
        />
        <img
            src="@/assets/img/graphics/transplant/referral-for-testing-mobile.svg"
            alt="Referral for Testing"
            class="md:hidden self-center"
        />
    </div>
</template>
